import { ref } from "vue";
import { defineStore } from "pinia";

import type { DsThemeColor } from "../../types";
import type { DsComponentRenderProp } from "../component-render/DsComponentRender.types";

export interface DsFlashMessage {
  content: string | DsComponentRenderProp;
  themeColor: DsThemeColor;
  id: string;
}

export const useDsFlashStore = defineStore("ds-flash", () => {
  const messages = ref<DsFlashMessage[]>([]);

  const add = (newMessage: DsFlashMessage): void => {
    const index = messages.value.findIndex((message) => {
      return message.id === newMessage.id;
    });
    //If index not found, add flash, otherwise update flash
    if (index === -1) {
      messages.value.push(newMessage);
    } else {
      messages.value[index] = newMessage;
    }
  };

  const remove = (id: string): void => {
    const index = messages.value.findIndex((message) => {
      return message.id === id;
    });
    //If index found, delete the flash
    if (index !== -1) {
      messages.value.splice(index, 1);
    }
  };

  return {
    messages,
    add,
    remove,
  };
});
